import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpTooltipComponent from './adpTooltip.component';

let adpTooltipModule = angular.module('adpTooltip', [
  uiRouter
])

.component('adpTooltip', adpTooltipComponent)

.name;

export default adpTooltipModule;



// WEBPACK FOOTER //
// ./src/app/components/adpTooltip/adpTooltip.js